<app-button-advanced
  [action]="viewChangesToolAction"
  [active]="forceHighlight"
  matTooltip="{{ 'viewer.Tools.ShowDiff' | translate }}"
  [matTooltipPosition]="'left'"
  [hotButton]="'C'"
  [matTooltipDisabled]="isDisabled$ | async"
>
</app-button-advanced>
